import { useContext } from "react";
import { ChatContext } from "../providers";

const useChat = () => {
  const chatContext = useContext(ChatContext);

  if (!chatContext) {
    throw new Error("useChat must be used within a ChatProvider");
  }

  return chatContext;
};

export default useChat;
